import { observable, action, computed, toJS } from 'mobx'
import Api from '@api/weiShop'
import { message } from 'hljd'
import { getSessionMerchantInfo } from '@merchant-backend/util'
import { isHotelMerchant } from '@util'

class Store {
  @observable merchant_info = {}
  @observable weiShopData = {}

  constructor() {
    this.merchant_info = getSessionMerchantInfo()
  }

  @observable is_preview = 0

  @observable qrcodeShow = false
  @action
  postInfoDataValue = value => () => {
    this.is_preview = +value
    this.postInfoData()
  }

  @action
  Qrcode = () => {
    this.qrcodeShow = !this.qrcodeShow
  }

  @observable title = this.merchant_info.name

  @observable can_show_announcement = 1
  @observable can_show_gift = 1
  @observable can_show_recommend = 1
  @observable can_show_feed = 1
  // 以下三个为酒店独有
  @observable can_show_feature = 1
  @observable can_show_exclusive_offer = 1
  @observable can_show_subscribe_news = 1

  onChange = e => {
    const { name, value } = e.target
    this[name] = value
  }

  @observable photos = []
  @action
  AddPhotos = img => {
    this.photos = this.photos.concat({ img })
  }
  @action
  removePhotos = index => {
    this.photos = this.photos.filter((item, i) => i !== index)
  }

  getInfoData = async () => {
    let { data } = await Api.getInfo()
    this.weiShopData = data
    if (!Array.isArray(data)) {
      this.title = data.title
      this.photos = data.photos || []

      if (isHotelMerchant()) {
        this.can_show_feature = data.can_show_feature
        this.can_show_exclusive_offer = data.can_show_exclusive_offer
        this.can_show_subscribe_news = data.can_show_subscribe_news
      } else {
        this.can_show_announcement = data.can_show_announcement
        this.can_show_gift = data.can_show_gift
        this.can_show_recommend = data.can_show_recommend
        this.can_show_feed = data.can_show_feed
      }
    }
  }

  postInfoData = async () => {
    const { is_preview } = this
    let params = this.getParams()
    if (!params.title) {
      return message.warning('未添加店铺名称')
    }
    let { success } = await Api.postInfo({ ...params, is_preview })
    if (success) {
      if (is_preview == 1) {
        this.qrcodeShow = !this.qrcodeShow
      } else {
        message.success('操作成功！')
        this.getInfoData()
      }
    }
  }

  getParams = () => {
    const {
      title,
      photos,
      can_show_announcement,
      can_show_gift,
      can_show_recommend,
      can_show_feed,
      can_show_feature,
      can_show_exclusive_offer,
      can_show_subscribe_news
    } = this

    let params = { title, photos }

    if (isHotelMerchant()) {
      params = {
        ...params,
        can_show_feature,
        can_show_exclusive_offer,
        can_show_subscribe_news
      }
    } else {
      params = {
        ...params,
        can_show_announcement,
        can_show_gift,
        can_show_recommend,
        can_show_feed
      }
    }

    return params
  }

  @computed
  get isWeiShopSet() {
    const data = toJS(this.weiShopData)
    return data != null && Object.keys(data).length > 0
  }
}
export default Store
